import {ItemType, ItemStatus} from "./enums/item-enums";
import ItemLocation from "./item-location";
import ItemWeight from "./item-weight";
import Instruction from "./instruction";

export default class Item {
    constructor() {
        this.itemId = "item1";
        this.scannableId = "item1";
        this.label = "label1";
        this.sequence = 1;
        this.itemType = ItemType.BAG;
        this.itemStatus = ItemStatus.STOWED;
        this.location = new ItemLocation();
        this.containerColor = "red";
        this.isMissedEver = false;
        this.weight = new ItemWeight();
        this.instructions = new Instruction();
    }
}


// WEBPACK FOOTER //
// ./src/models/item.js